import React from "react";
import work1 from "../images/work1.png";
import work2 from "../images/work2.png";
import { Container, Row, Col, Tab } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import ProjectCard from "./ProjectCard";
import colorSharp from "../images/color-sharp2.png";
import TrackVisibility from "react-on-screen";
import "animate.css";
import projects1 from "../images/projects1.png";
import projects2 from "../images/projects2.png";
import projects3 from "../images/projects3.png";
import projects4 from "../images/projects4.png";
import projects5 from "../images/projects5.png";
import projects6 from "../images/projects6.png";
import course1 from "../images/course1.png";
import course2 from "../images/course2.png";
import link from "../images/link-solid.svg";

const Projects = () => {
  const work = [
    {
      title: "GrzegorzMiecznikowski.pl",
      description: "Agency website",
      url: "https://grzegorzmiecznikowski.pl/",
      imgUrl: work1,
    },
    {
      title: "4NonStraights.pl",
      description: "Non-governmental organization",
      url: "https://4nonstraights.pl/",
      imgUrl: work2,
    },
  ];

  const projects = [
    {
      title: "SHOPSHOPSHOP",
      description: "Online Shop",
      url: "https://p-niet.github.io/shopshopshop-app/",
      imgUrl: projects1,
      code: "https://github.com/p-niet/shopshopshop-app/tree/code",
    },
    {
      title: "REST Countries API",
      description: "with color theme switcher",
      url: "https://p-niet.github.io/flags-exercise/",
      imgUrl: projects2,
      code: "https://github.com/p-niet/flags-exercise/tree/main",
    },
    {
      title: "ReactDex",
      description: "PokeDex app",
      url: "https://p-niet.github.io/ReactDex/",
      imgUrl: projects3,
      code: "https://github.com/p-niet/ReactDex/tree/main",
    },
    {
      title: "The Maze Game",
      description: "Halloween Parody",
      url: "https://p-niet.github.io/maze/",
      imgUrl: projects4,
      code: "https://github.com/p-niet/maze/tree/code",
    },
    {
      title: "Pomodoro clock",
      description: "FreeCodeCamp assignment",
      url: "https://codepen.io/paszczuh/full/eYWzWQJ",
      imgUrl: projects5,
      code: "https://codepen.io/paszczuh/pen/eYWzWQJ",
    },
    {
      title: "Calculator",
      description: "FreeCodeCamp assignment",
      url: "https://codepen.io/paszczuh/full/PopxGaY",
      imgUrl: projects6,
      code: "https://codepen.io/paszczuh/pen/PopxGaY",
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? "" : ""}>
                  <h2>Projects</h2>
                  <p>
                    Below you can find a selection of client projects and my
                    other professional work, projects which are some of my spare
                    time tinkering as well as my certificates.
                  </p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav
                      variant="pills"
                      className="nav-pills mb-5 justify-content-center align-items-center"
                      id="pills-tab"
                    >
                      <Nav.Item>
                        <Nav.Link eventKey="first">WORK</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">PROJECTS</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third">COURSES</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content id="slideInUp" className={isVisible ? "" : ""}>
                      <Tab.Pane eventKey="first">
                        <Row style={{ justifyContent: "center" }}>
                          {work.map((work, index) => {
                            return <ProjectCard key={index} {...work} />;
                          })}
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="second">
                        <Row style={{ justifyContent: "center" }}>
                          {projects.map((projects, index) => {
                            return <ProjectCard key={index} {...projects} />;
                          })}
                        </Row>
                      </Tab.Pane>

                      <Tab.Pane eventKey="third">
                        <Row style={{ justifyContent: "center" }}>
                          <Col size={12} sm={6} md={4}>
                            <div className="proj-imgbx">
                              <img src={course1} />
                              <div className="proj-txtx">
                                <h4>JavaScript</h4>
                                <span>
                                  Algorithms and Data Structures
                                  <br />
                                  FreeCodeCamp.com
                                </span>
                                <div className="projects-link">
                                  <a
                                    href="https://www.freecodecamp.org/certification/paszczuh/javascript-algorithms-and-data-structures"
                                    className="projects-href"
                                  >
                                    <img
                                      src={link}
                                      alt="Link"
                                      style={{
                                        height: "16px",
                                        width: "16px",
                                        filter:
                                          "invert(100%) sepia(100%) saturate(0%) hue-rotate(112deg) brightness(102%) contrast(103%)",
                                      }}
                                    />{" "}
                                    <h5>Certificate</h5>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col size={12} sm={6} md={4}>
                            <div className="proj-imgbx">
                              <img src={course1} />
                              <div className="proj-txtx">
                                <h4>Front End</h4>
                                <span>
                                  Development Libraries
                                  <br />
                                  FreeCodeCamp.com
                                </span>
                                <div className="projects-link">
                                  <a
                                    href="https://www.freecodecamp.org/certification/paszczuh/front-end-development-libraries"
                                    className="projects-href"
                                  >
                                    <img
                                      src={link}
                                      alt="Link"
                                      style={{
                                        height: "16px",
                                        width: "16px",
                                        filter:
                                          "invert(100%) sepia(100%) saturate(0%) hue-rotate(112deg) brightness(102%) contrast(103%)",
                                      }}
                                    />{" "}
                                    <h5>Certificate</h5>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp}></img>
    </section>
  );
};

export default Projects;
